module.exports = __webpack_public_path__ + "img/81.4526f6b3.webp";